module.exports = __webpack_public_path__ + "static/img/9.c9b05f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/9.png
// module id = b8+8
// module chunks = 0